// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as IssuesApiModel from "../api-model/IssuesApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function apiModelToState(res) {
  return {
          issues: List.map((function (data) {
                  return {
                          issue_name: data.issue_name,
                          issue_comment_required: data.issue_comment_required
                        };
                }), res.issues)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(IssuesApiModel.t_decode(json), "IssuesEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
